export default "__VITE_ASSET__COMjjxIS__"